import { call } from "redux-saga/effects";
import { APIS } from "../../_config";
import { CallApi } from "../api/callApi";
import { sagaFunction } from "../api/functions";

export function* getManualProductTaxableSettings(action: any): any {
    yield call(sagaFunction, action, CallApi.GET, APIS.SETTINGS_MANUAL_PRODUCT_TAXABLE.GET, null, true);
}

export function* saveManualProductTaxableSettings(action: any): any {
    yield call(sagaFunction, action, CallApi.POST, APIS.SETTINGS_MANUAL_PRODUCT_TAXABLE.SAVE, action.payload, true);
}
